import { API } from '@/redux/config/index';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useCustomerId, useSiteId } from '../../utils/hooks/useCustomerId';
import { getLocalStorageData, setLocalStorageData } from '../../utils/LocalStorage';
import { StnAPI } from '../config/customHeadersApi';
import { raiseErrorException } from '../../utils/raiseErrorException';
import {
  setAllJiraProjects,
  setAllJiraTickets,
  setAllProjects,
  setAllProjectsAndSubtickets,
  setAnalyseAlertData,
  setAnalyseAlertDataWithAlertID,
  setAssignees,
  setBulkTicketUpdate,
  setCustomerProjects,
  setCustomerTickets,
  setCustomerTicketsIssues,
  setDeletedTicket,
  setFieldData,
  setGetAllAdminNotes,
  setJiraApiKey,
  setJiraApiKeyStatus,
  setJiraAttachmentContent,
  setJiraAuthenticationURL,
  setJiraAuthorization,
  setJiraTicketByKey,
  setJiraTickets,
  setJiraTicketSearch,
  setJiraToken,
  setJiraWorklog,
  setJiraWorklogData,
  setMergedTicket,
  setMyProjectsAndSubtickets,
  setNewTicketAndAllTickets,
  setProjectByKey,
  setProjectSubTicketByKey,
  setProjectTicketsLoading,
  setReducerError,
  setRefreshToken,
  setSelectedCustomerAssignees,
  setServiceCodes,
  setTicketCommentsData,
  setTicketsProjects,
  setToggleBulkUpdateModal,
  setToggleModal,
  setUnmergedTicket,
  setUserTicketData,
  setUserTickets,
  start,
  startAdminNotes,
  startAssigneeFieldLoading,
  startAssigneesLoading,
  startCustomerIDFieldLoading,
  startDescriptionFieldLoading,
  startDueDateFieldLoading,
  startJiraAttachmentContent,
  startJiraWorklog,
  startLabelsFieldLoading,
  startPriorityFieldLoading,
  startProjectFieldLoading,
  startReporterFieldLoading,
  startServiceCodeFieldLoading,
  startSiteIDFieldLoading,
  startStartDateFieldLoading,
  startStatusSummaryFieldLoading,
  startTicketComments,
  startTicketTransition,
  startTimeEstimateFieldLoading,
  startUserTicketData,
  stopAdminNotes,
  stopAssigneeFieldLoading,
  stopAssigneesLoading,
  stopCustomerIDFieldLoading,
  stopDescriptionFieldLoading,
  stopDueDateFieldLoading,
  stopJiraAttachmentContent,
  stopJiraWorklog,
  stopLabelsFieldLoading,
  stopPriorityFieldLoading,
  stopProjectFieldLoading,
  stopReporterFieldLoading,
  stopServiceCodeFieldLoading,
  stopSiteIDFieldLoading,
  stopStartDateFieldLoading,
  stopStatusSummaryFieldLoading,
  stopTicketComments,
  stopTicketTransition,
  stopTimeEstimateFieldLoading,
  stopUserTicketData,
  startSpecialInstructionsLoading,
  stopSpecialInstructionsLoading,
  setSpecialInstructionsData,
  setIsLoadingJiraWorklog,
  startCustomerProjectsLoading,
  stopCustomerProjectsLoading,
  startAssignTeamFieldLoading,
  stopAssignTeamFieldLoading,
  startTeamFieldLoading,
  stopTeamFieldLoading,
  setJiraTicketTeamData,
} from '../reducers/jiraTicketsReducer';
import { UpdateCredsAction } from './authActions';

// get all projects and subtickets
export const getAllProjectsAndSubtickets = (filterOnly, assignee, cancelToken, currentLocation) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get('/jira/projects/tickets', {
      params: {
        showSupport: false,
        ...(filterOnly ? { filterOnly } : ''),
        ...(assignee ? { assignee } : ''),
      },
      cancelToken: cancelToken ? cancelToken.token : '',
    });
    if (filterOnly === 'mine') {
      return dispatch(setMyProjectsAndSubtickets(response?.data));
    }
    dispatch(setAllProjectsAndSubtickets(response?.data));
    const tenMinutes = 1000 * 60 * 10;
    let resetTimer = setTimeout(() => {
      if (currentLocation) {
        if (currentLocation !== '/allprojects/') {
          dispatch(setAllProjectsAndSubtickets([]));
        }
      }
    }, tenMinutes);

    return () => clearTimeout(resetTimer);
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
//  Edit Comment To Jira Ticket Test
export const EditCommentToTicketWithTicketID =
  (key, text, commentID, permissions, scopePermissions) => async (dispatch) => {
    try {
      dispatch(start());
      const response = await API.put(`/jira/${key}/comment/${commentID}`, {
        comment: text,
      });

      dispatch(setJiraTicketByKey(response?.data));
      if (scopePermissions?.isStnUser && permissions?.read) {
        dispatch(getAdminNotesToTicketWithTicketID(key));
      }
      dispatch(getAllTicketComments(key));
      toast.success('Comment Updated Successfully');
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError);
    }
  };
//  get admin notes To Jira Ticket
export const getAdminNotesToTicketWithTicketID = (key) => async (dispatch) => {
  try {
    dispatch(startAdminNotes());
    const response = await API.get(`/jira/${key}/adminnotes`);

    return dispatch(setGetAllAdminNotes(response?.data));
  } catch (err) {
    dispatch(stopAdminNotes());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

//  Add admin notes To Jira Ticket
export const addAdminNotesToTicketWithTicketID = (key, data) => async (dispatch) => {
  try {
    dispatch(startAdminNotes());
    const response = await API.put(`/jira/${key}/adminnotes`, data);

    return dispatch(setGetAllAdminNotes(response?.data));
  } catch (err) {
    // toast.error(err?.response?.data?.detail || 'An error occurred while adding the Admin Note');
    dispatch(stopAdminNotes());
    raiseErrorException(err, dispatch, setReducerError);
  }
};

// start syncing jira metadata (action not used)
export const syncJiraMetadata = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get('/jira/sync');
    return;
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// authenticate with jira (unused)
export const authorizeWithJira = (code, state) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/jira/authorize?code=${code}&state=${state}`);

    dispatch(setJiraAuthorization(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const getJiraToken = (userID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/jira/token?userID=${userID}`);
    return dispatch(setJiraToken(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const authenticateWithJira = (userID, key) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/jira/authenticate?userID=${userID}&ticketKey=${key}`);
    window.location.href = response?.data;
    dispatch(setJiraAuthenticationURL(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get All Support Tickets
export const getAllJiraTickets = (startAt, endAt, dateStart, dateEnd) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/jira?showMerged=false&startAt=${startAt}&maxResults=${endAt}`, {
      params: {
        ...(dateStart && { dateStart }),
        ...(dateEnd && { dateEnd }),
      },
    });
    return dispatch(setJiraTickets(response?.data?.issues));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
// Get All Support Tickets
export const getAllJiraSupportTickets = (startAt, endAt, dateStart, dateEnd) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/jira/?showMerged=false&startAt=${startAt}&maxResults=${endAt}`, {
      params: {
        ...(dateStart && { dateStart }),
        ...(dateEnd && { dateEnd }),
      },
    });
    return dispatch(setAllJiraTickets(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// get support tickets assigned to user and
export const getJiraTicketsByUser = (userID, dateStart, dateEnd) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/jira/assignee/${userID}`, {
      params: {
        dateStart: dateStart,
        dateEnd: dateEnd,
      },
    });
    return dispatch(setUserTickets(response?.data?.issues));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Jira Ticket
export const getJiraTicketByKey =
  (key, fromMergedTable = false) =>
  async (dispatch) => {
    // if fromMergedTable: pass ticket details to mergedTicket in state
    try {
      dispatch(start());
      const response = await API.get(`/jira/${key}`);

      if (fromMergedTable) {
        return dispatch(setMergedTicket(response?.data));
      } else {
        return dispatch(setJiraTicketByKey(response?.data));
      }
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
    }
  };
// Get Jira Ticket
export const getJiraTicketDetailsByKey = (key) => async (dispatch) => {
  try {
    const response = await API.get(`/jira/${key}`);

    return dispatch(setJiraTicketByKey(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Search Jira support tickets (review done)
export const searchJiraTickets = (search, customerID, dateStart, dateEnd, startAt, maxResults) => async (dispatch) => {
  try {
    dispatch(start());
    if (dateStart === null) {
      const response = await API.get(
        `/jira/search?search=${search}&filterCustomer=${customerID}&startAt=${startAt}&maxResults=${maxResults}`,
      );

      return dispatch(setJiraTicketSearch(response?.data?.issues));
    }
    if (dateStart !== null && search !== '') {
      const response = await API.get(
        `/jira/search?search=${search}&filterCustomer=${customerID}&dateStart=${dateStart}
        &dateEnd=${dateEnd}&startAt=${startAt}&maxResults=${maxResults}`,
      );

      return dispatch(setJiraTicketSearch(response?.data?.issues));
    }
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const resetJiraForm = () => async (dispatch) => dispatch(setToggleModal());

// Refresh Token
export const getJiraTokenRefresh = (jiraAuthenticationURL, selectedKey) => async (dispatch) => {
  try {
    const refresh = getLocalStorageData('jiraRefreshToken');
    const userID = getLocalStorageData('loggedInUserID');
    const config = {
      headers: {
        refreshToken: `${refresh}`,
      },
    };
    dispatch(start());
    const response = await API.get(`/jira/token/refresh?userID=${userID}`, config);

    setLocalStorageData('jiraToken', response.data.access_token);
    setLocalStorageData('jiraRefreshToken', response.data.refresh_token);
    toast.success('Tokens Updated Successfully');

    return dispatch(setRefreshToken(response?.data));
  } catch (err) {
    const userID = getLocalStorageData('loggedInUserID');

    dispatch(authenticateWithJira(userID, selectedKey));
    if (err.response?.status === 401) {
      return (window.location.href = jiraAuthenticationURL);
    }

    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Worklog on jira Issue
export const getWorklogToJiraTicket = (issueKey) => async (dispatch) => {
  try {
    dispatch(startJiraWorklog());
    const response = await API.get(`/jira/${issueKey}/worklogs`);

    dispatch(setJiraWorklogData(response?.data?.worklogs));
    // dispatch(setFieldData({ field: 'timeEstimate', value: response?.data?.timeEstimate }));
    dispatch(setFieldData({ field: 'timeover', value: response?.data?.timeover }));
    dispatch(setFieldData({ field: 'timespent', value: response?.data?.timespent }));
    dispatch(setFieldData({ field: 'remainingtimeestimate', value: response?.data?.remainingtimeestimate }));
  } catch (err) {
    dispatch(stopJiraWorklog());
    raiseErrorException(err, dispatch, setReducerError, 'get');
    // toast.error(err?.response?.data?.detail);
  }
};
// Add Worklog on jira Issue
export const addWorklogToJiraTicket =
  (
    issueKey,
    timeSpent,
    comment,
    serviceCode,
    started,
    userID,
    toggle,
    overrideInvalidToken = false,
    jiraAuthenticationURL = null,
    afterRefresh = false,
    data,
    handleClickAddWorklog,
    behalfOfUserId,
  ) =>
  async (dispatch) => {
    try {
      dispatch(startJiraWorklog());
      const response = await StnAPI.post(`/jira/${issueKey}/worklog`, {
        timeSpent,
        comment,
        started,
        serviceCode,
        userID,
        overrideInvalidToken,
        behalfOfUserId,
      });

      dispatch(setJiraWorklog(response?.data));
      toast.success('Worklog Successfully Added');
      if (toggle) {
        toggle();
      }

      dispatch(getWorklogToJiraTicket(issueKey));
    } catch (err) {
      // toast.error(err?.response?.data?.detail);
      if (handleClickAddWorklog) {
        handleClickAddWorklog();
      }
      if (toggle) {
        toggle();
      }

      if (!behalfOfUserId) {
        // Only attempt token refresh and authentication if jiraAuthenticationURL is provided
        if (jiraAuthenticationURL) {
          if (!afterRefresh && err?.response?.status === 401) {
            await dispatch(getJiraTokenRefresh(jiraAuthenticationURL, issueKey));
            dispatch(
              addWorklogToJiraTicket(
                issueKey,
                timeSpent,
                comment,
                serviceCode,
                started,
                userID,
                toggle,
                overrideInvalidToken,
                jiraAuthenticationURL,
                true,
              ),
            );
          } else {
            dispatch(authenticateWithJira(userID, issueKey));
          }
        }
        dispatch(getJiraTicketByKey(issueKey));
        dispatch(getJiraProjectByKey(issueKey));
      }
      dispatch(stopJiraWorklog());
      raiseErrorException(err, dispatch, setReducerError, 'post');
    }
  };

// Update Worklog on jira Issue
export const updateWorklogToJiraTicket =
  (id, issueKey, timeSpent, comment, serviceCode, started) => async (dispatch) => {
    try {
      dispatch(start());
      dispatch(setIsLoadingJiraWorklog(true));
      const response = await StnAPI.put(`/jira/${issueKey}/worklog/${id}`, {
        timeSpent,
        comment,
        started,
        serviceCode,
      });

      dispatch(setJiraWorklog(response?.data));
      toast.success('Worklog Successfully Updated');
      dispatch(getWorklogToJiraTicket(issueKey));
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
      // toast.error(err?.response?.data?.detail);
      dispatch(getJiraTicketByKey(issueKey));
      dispatch(getJiraProjectByKey(issueKey));
    }
  };

// Update Reporter Jira Ticket
export const updateReporterForJiraTicketByKey = (key, email, name, setToggle) => async (dispatch) => {
  try {
    toast.warn('Ticket Update is in progress');
    dispatch(start());
    const response = await API.put(`/jira/${key}`, {
      reporter: { email, name },
    });

    dispatch(setJiraTicketByKey(response?.data));
    toast.success('Ticket Successfully Updated');
    toast.success('It may take up to 2 minutes for changes to reflect');
    setToggle(false);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
    // toast.error(err?.response?.data?.detail);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  }
};

// Update Jira Ticket
export const updateJiraTicketByKey = (key, priority, assigneeEmail, setToggle) => async (dispatch) => {
  try {
    toast.info('Ticket Update is in progress');
    dispatch(start());
    const response = await API.put(`/jira/${key}`, {
      priority,
      assigneeEmail,
    });

    dispatch(setJiraTicketByKey(response?.data));
    toast.success('Ticket Successfully Updated. It may take up to 2 minutes for changes to reflect');
    setToggle(false);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
    // toast.error(err?.response?.data?.detail);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  }
};
// Update Jira Ticket
export const updateJiraTicketByKeyForProjectAndAssignee = (key, data, setModal, detailPage) => async (dispatch) => {
  try {
    toast.info('Ticket Update is in progress');
    dispatch(start());
    const response = await API.put(`/jira/${key}`, data);

    dispatch(setJiraTicketByKey(response?.data));
    if (detailPage) {
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
    }
    if (setModal) {
      setModal(false);
    }
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
    // toast.error(err?.response?.data?.detail);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  }
};
// Update Jira Ticket in Custom Table
export const updatePriorityForJiraTicketByKeyForCustomTable =
  (key, priority, id, dataLabel, updateCellValue, fetchData, currentPage) => async (dispatch) => {
    try {
      toast.warn('Ticket Update is in progress');
      dispatch(start());
      const response = await API.put(`/jira/${key}`, {
        priority,
      });

      dispatch(setJiraTicketByKey(response?.data));
      toast.success('Ticket Successfully Updated');

      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
      updateCellValue(priority, id, dataLabel);
      fetchData(currentPage);
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
      // toast.error(err?.response?.data?.detail);
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
    }
  };

// Update Jira Ticket Team in Custom Table
export const updateTeamForJiraTicketByKeyForCustomTable =
  (key, team, id, dataLabel, updateCellValue, fetchData, currentPage) => async (dispatch) => {
    try {
      toast.warn('Ticket Update is in progress');
      dispatch(start());
      const response = await API.put(`/jira/${key}`, {
        team,
      });

      dispatch(setJiraTicketByKey(response?.data));
      toast.success('Ticket Successfully Updated');

      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
      updateCellValue(team, id, dataLabel);
      fetchData(currentPage);
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
      // toast.error(err?.response?.data?.detail);
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
    }
  };

// Update Jira Ticket in Custom Table
export const updateAssigneeForJiraTicketByKeyForCustomTable =
  (key, priority, assigneeEmail, label, id, dataLabel, updateCellValue, fetchData, currentPage) => async (dispatch) => {
    try {
      toast.warn('Ticket Update is in progress');
      dispatch(start());
      const response = await API.put(`/jira/${key}`, {
        priority,
        assigneeEmail,
      });
      // debugger

      dispatch(setJiraTicketByKey(response?.data));
      toast.success('Ticket Successfully Updated');

      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
      await fetchData(currentPage);
      // updateCellValue(label, id, dataLabel)
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
      // toast.error(err?.response?.data?.detail);
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
    }
  };

export const updateJiraTicketServiceCodeByKey = (key, servicecode, setToggle) => async (dispatch) => {
  try {
    toast.warn('Ticket Update is in progress');
    dispatch(start());
    const response = await API.put(`/jira/${key}`, {
      servicecode,
    });
    dispatch(setJiraTicketByKey(response?.data));
    toast.success('Ticket Successfully Updated');
    toast.success('It may take up to 2 minutes for changes to reflect');
    setToggle(false);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
    // toast.error(err?.response?.data?.detail);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  }
};

// Update Jira Ticket
export const updateJiraTicketDescriptionByKey = (key, description, setShowDetailsDescription) => async (dispatch) => {
  try {
    toast.warn('Ticket Update is in progress');
    dispatch(start());
    const response = await API.put(`/jira/${key}`, description);

    dispatch(setJiraTicketByKey(response?.data));
    toast.success('Ticket Successfully Updated');
    setShowDetailsDescription(false);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
    // toast.error(err?.response?.data?.detail);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  }
};

// Update Jira Ticket
export const updateJiraTicketCompanyByKey = (key, data, setShowDetailsDescription) => async (dispatch) => {
  try {
    toast.warn('Ticket Update is in progress');
    dispatch(start());
    const response = await API.put(`/jira/${key}`, data);
    dispatch(setJiraTicketByKey(response?.data));
    toast.success('Ticket Successfully Updated');
    setShowDetailsDescription(false);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  } catch (err) {
    setShowDetailsDescription(false);
    raiseErrorException(err, dispatch, setReducerError, 'get');
    // toast.error(err?.response?.data?.detail);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  }
};
// Update Jira Ticket
export const updateJiraTicketCompanyByKeyForCustomTable =
  (key, customerID, setShowDetailsDescription) => async (dispatch) => {
    try {
      toast.warn('Ticket Update is in progress');
      dispatch(start());
      const response = await API.put(`/jira/${key}`, { customerID });
      dispatch(setJiraTicketByKey(response?.data));
      toast.success('Ticket Successfully Updated');
      setShowDetailsDescription(false);
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
      // toast.error(err?.response?.data?.detail);
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
    }
  };

// Update Jira Ticket
export const updateJiraTicketDetailsByKey =
  (key, setToggle, ...additionalParams) =>
  async (dispatch) => {
    try {
      toast.warn('Ticket Update is in progress');
      dispatch(start());
      const response = await API.put(`/jira/${key}`, {
        ...additionalParams.reduce((acc, param) => {
          acc[param.name] = param.value;
          return acc;
        }, {}),
      });

      dispatch(setJiraTicketByKey(response?.data));
      toast.success('Ticket Successfully Updated');
      toast.success('It may take up to 2 minutes for changes to reflect');
      setToggle(false);
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
      // toast.error(err?.response?.data?.detail);
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
    }
  };

export const updateJiraTicketDetailsByKeyForCustomTable =
  (key, label, id, dataLabel, updateCellValue, fetchData, currentPage, ...additionalParams) =>
  async (dispatch) => {
    try {
      dispatch(start());
      const response = await API.put(`/jira/${key}`, {
        ...additionalParams.reduce((acc, param) => {
          acc[param.name] = param.value;
          // }
          return acc;
        }, {}),
      });

      dispatch(setJiraTicketByKey(response?.data));
      toast.success('Ticket Successfully Updated');
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
      updateCellValue(label, id, dataLabel);
      fetchData(currentPage);
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
      // toast.error(err?.response?.data?.detail);
      dispatch(getJiraTicketByKey(key));
      dispatch(getJiraProjectByKey(key));
    }
  };

// Delete Jira Ticket
export const deleteJiraTicketByKey = (key) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/jira/${key}`);

    return dispatch(setDeletedTicket(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Jira Tickets of Customer
export const getJiraTicketsByCustomer =
  (customerID, cancelToken, startAt, maxResults, dateStart, dateEnd) => async (dispatch) => {
    try {
      dispatch(start());
      let response = {};
      if (dateStart) {
        response = await API.get(
          // eslint-disable-next-line max-len
          `/jira/customer/tickets?dateStart=${dateStart}&dateEnd=${dateEnd}&showMerged=false&startAt=${startAt}&maxResults=${maxResults}`,
          {
            cancelToken,
          },
        );
      } else {
        response = await API.get(
          `/jira/customer/tickets?showMerged=false&startAt=${startAt}&maxResults=${maxResults}`,
          {
            cancelToken,
          },
        );
      }
      if (!response?.data?.startAt) {
        return dispatch(setCustomerTickets(response?.data));
      }
      return dispatch(setCustomerTicketsIssues(response?.data?.issues));
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
    }
  };

// BulkUpdateTickets (review done)
export const bulkUpdateTickets =
  (data, isMerged, ids, setModal, modal, setSelected, toggling, setToggling, setSelectedRowData, fetchData) =>
  async (dispatch) => {
    const cancelTokenSource = axios.CancelToken.source();
    try {
      let response = {};
      dispatch(start());

      const cleanup = () => {
        localStorage.removeItem('selectedKeys');
        if (setSelected) {
          setSelected(new Map([]));
        }
        if (setModal) {
          setModal(false);
        }
        if (setSelectedRowData) {
          setSelectedRowData([]);
        }
      };

      const handleUIUpdates = async () => {
        cleanup();
        if (setToggling) {
          setToggling(!toggling);
        }
        if (fetchData) {
          await fetchData(1, 10, '-updated', '', '', '', '', true);
        }
      };

      const hasUpdateFields =
        data.assigneeEmail || data.priority || data.project || data.ticketKeyIds || data.transitionID;

      if (isMerged === true && hasUpdateFields) {
        await dispatch(mergeJiraTickets(ids, useCustomerId()));
        response = await API.put('/jira/', data, {
          cancelToken: cancelTokenSource.token,
        });

        if (response?.status === 200) {
          dispatch(setBulkTicketUpdate(response?.data));
          await dispatch(getJiraTicketsByCustomer(useCustomerId(), cancelTokenSource.token, 0, 3000));
          toast.success('Tickets Successfully Updated');
          await handleUIUpdates();
        } else {
          throw new Error('Failed to update merged tickets');
        }
        return;
      }

      if (isMerged === false && hasUpdateFields) {
        response = await API.put('/jira/', data, {
          cancelToken: cancelTokenSource.token,
        });

        if (response?.status === 200) {
          dispatch(setBulkTicketUpdate(response?.data));
          toast.success('Tickets Successfully Updated');
          await handleUIUpdates();
        } else {
          throw new Error('Failed to update tickets');
        }
        return;
      }

      if (isMerged === true) {
        await dispatch(mergeJiraTickets(ids, useCustomerId()));
        await dispatch(getJiraTicketsByCustomer(useCustomerId(), cancelTokenSource.token, 0, 500));
        await dispatch(getAllJiraTickets(0, 500));
        await handleUIUpdates();
        return;
      }

      if (setToggling) {
        setToggling(!toggling);
      }
    } catch (err) {
      const errMsg = err?.response?.data?.detail[0]?.msg || err?.response?.data?.detail || err.message;
      // toast.error(errMsg);

      try {
        await dispatch(getJiraTicketsByCustomer(useCustomerId(), cancelTokenSource.token, 0, 500));
      } catch (refreshErr) {
        console.error('Failed to refresh tickets after error:', refreshErr);
      }

      raiseErrorException(err, dispatch, setReducerError, 'get');
    } finally {
      cancelTokenSource.cancel();
    }
  };

// Merge Jira Tickets
export const mergeJiraTickets = (ids, customerID, setSelected) => async (dispatch) => {
  dispatch(start());
  const message = toast.loading('Please wait while the tickets are merged');
  try {
    const response = await API.post('/jira/merge', { ids });

    dispatch(setMergedTicket(response?.data));
    toast.update(message, {
      render: 'Tickets Successfully Merged',
      type: 'success',
      isLoading: false,
      closeButton: true,
    });
    toast.success('It may take up to 2 minutes for changes to reflect');
    const cancelTokenSource = axios.CancelToken.source();
    dispatch(getJiraTicketsByCustomer(customerID, cancelTokenSource.token, 0, 500));
    dispatch(getAllJiraTickets(0, 500));
    if (setSelected) {
      setSelected(new Map([]));
    }
  } catch (err) {
    const errMsg = err?.response?.data?.detail[0]?.msg || err?.response?.data?.detail;
    toast.update(message, {
      render: errMsg,
      type: 'error',
      isLoading: false,
      closeButton: true,
    });

    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// un Merge Jira Tickets
export const unMergeJiraTickets = (ids) => async (dispatch) => {
  dispatch(start());
  const data = {
    ids: ids,
  };
  try {
    const response = await API.delete(`/jira/merge`, { data: data });
    dispatch(setUnmergedTicket(response?.data));
    toast.success('It may take up to 2 minutes for changes to reflect');
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get All Projects of Customer
export const getCustomerProjects = (customerID, cancelToken) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/jira/customer/project`, {
      cancelToken: cancelToken.token,
    });

    return dispatch(setCustomerProjects(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const getTicketsProjects = (customerID, currentSiteID, cancelToken) => async (dispatch) => {
  try {
    console.log('getTicketsProjects');
    dispatch(start());
    const response = await StnAPI.get(`/jira/customer/project`, {
      cancelToken: cancelToken.token,
      headers: {
        'x-customer-id': customerID,
        'x-site-id': currentSiteID,
      },
    });

    return dispatch(setTicketsProjects(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const getAllCustomerProjects = (customerID, currentSiteID) => async (dispatch) => {
  try {
    dispatch(start());

    const response = await StnAPI.get(`/jira/customer/project`, {
      headers: {
        'x-customer-id': customerID,
        'x-site-id': currentSiteID || useSiteId(),
      },
    });

    return dispatch(setCustomerProjects(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const getAllCustomerProjectsForAllTicketsPage = (customerID) => async (dispatch) => {
  try {
    dispatch(startCustomerProjectsLoading());

    const response = await StnAPI.get(`/jira/customer/project`, {
      headers: {
        'x-customer-id': customerID,
        'x-site-id': 'all',
      },
    });

    return dispatch(setCustomerProjects(response?.data));
  } catch (err) {
    dispatch(stopCustomerProjectsLoading());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Tickets of Projects
export const getProjectTicketsByProjectID = (projectKeyID, cancelToken) => async (dispatch) => {
  try {
    dispatch(start());
    dispatch(setProjectSubTicketByKey([]));
    dispatch(setProjectTicketsLoading(true));
    const response = await API.get(`/jira/project/${projectKeyID}/tickets?showSubtasks=false`, {
      cancelToken,
    });
    dispatch(setProjectTicketsLoading(false));
    return dispatch(setProjectSubTicketByKey(response?.data));
  } catch (err) {
    dispatch(setProjectTicketsLoading(false));
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Jira Ticket
export const getJiraProjectByKey =
  (key, fromSubticketTable = false) =>
  async (dispatch) => {
    // if fromSubticketTable, store project ticket details in projectSubTicketByKey in state
    try {
      dispatch(start());
      const response = await API.get(`/jira/${key}`);

      if (fromSubticketTable) {
        if (response?.data?.isSupportTicket) {
          // some ticket actions expect details to be in jiraTickets.ticket
          dispatch(setJiraTicketByKey(response?.data));
        }
        return dispatch(setProjectSubTicketByKey(response?.data));
      } else {
        return dispatch(setProjectByKey(response?.data));
      }
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
    }
  };

//  Get Comments From Jira Ticket (action not used)
export const getAllTicketComments = (key) => async (dispatch) => {
  try {
    dispatch(startTicketComments());
    const response = await API.get(`/jira/${key}/comment`);
    console.log(response, 'response');
    return dispatch(setTicketCommentsData(response?.data));
  } catch (err) {
    dispatch(stopTicketComments());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

//  Add Comment To Jira Ticket
export const addCommentToTicketWithTicketID = (key, text, permissions, scopePermissions) => async (dispatch) => {
  try {
    dispatch(startTicketComments());
    const response = await API.post(`/jira/${key}/comment`, {
      comment: text,
    });
    dispatch(setJiraTicketByKey(response?.data));
    // if (scopePermissions?.isStnUser && permissions?.read) {
    //   dispatch(getAdminNotesToTicketWithTicketID(key));
    // }
    // dispatch(getJiraProjectByKey(key));
    dispatch(getAllTicketComments(key));
    toast.success('Comment Added Successfully');
  } catch (err) {
    toast.error(err?.response?.data?.detail || 'An error occurred while adding the comment');
    dispatch(stopTicketComments());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Download Attachment Content
export const getCommentAttachmentContent =
  (key, link, isImg = false) =>
  async () => {
    try {
      const response = await API.get(`/jira/${key}/attachment`, {
        params: { link },
        responseType: 'blob',
      });
      if (isImg) {
        return response;
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', response.headers['content-disposition']);
      document.body.appendChild(a);
      a.click();
      a.remove();
      return null;
    } catch (err) {
      console.error('An error encountered: Could not retrieve attachment content');
      return null;
    }
  };
export const getAttachmentContent = (key, initialRender) => async (dispatch) => {
  try {
    dispatch(startJiraAttachmentContent());
    const response = await API.get(`/jira/${key}/attachments`);
    dispatch(setJiraAttachmentContent(response?.data));
    if (!initialRender) {
      dispatch(getAllTicketComments(key));
    }
  } catch (err) {
    dispatch(stopJiraAttachmentContent());
    dispatch(setJiraAttachmentContent([]));
    toast.error('An error encountered: Could not retrieve attachment content');
    return null;
  }
};

export const getCommentAttachment = (key, link) => async (setFileContent, setLoading) => {
  try {
    const response = await API.get(`/jira/${key}/attachments`, {
      params: { link },
      responseType: 'blob',
    });

    if (response) {
      const fileData = response.data;
      const fileType = fileData.type;
      setFileContent({
        data: fileData,
        type: fileType,
      });
      setLoading(false);
      return { data: fileData, type: fileType };
    }
  } catch (err) {
    console.error('An error encountered: Could not retrieve attachment content', err);
    setLoading(false);
    return null;
  }
};

// get attachment content (attachment link passed as query param)
export const attachFileToJiraTicketByKey = (key, files, toggle) => async (dispatch) => {
  try {
    dispatch(startJiraAttachmentContent());

    const data = new FormData();

    // Handle multiple files
    if (Array.isArray(files)) {
      files.forEach((file) => data.append('files', file));
    } else if (files) {
      // Handle single file
      data.append('files', files);
    }

    const response = await API.post(`/jira/${key}/attachment`, data);
    dispatch(getAttachmentContent(key));

    toast.success('Attachment Added Successfully');
    if (toggle) {
      toggle();
    }
    return response.data;
  } catch (err) {
    const errorMessage = err?.response?.data?.detail || 'An error occurred while adding the attachment';
    // dispatch(setReducerError(errorMessage));
    raiseErrorException(err, dispatch, setReducerError, 'post');
    dispatch(stopJiraAttachmentContent());
    toast.error(errorMessage);
  }
};

// Add a shared participant to a ticket
export const addParticipantToTicket = (key, email) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/jira/${key}/participant`, { email });
    toast.success('Participant Successfully Added');
    toast.success('It may take up to 2 minutes for changes to reflect');
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'post');
  }
};

export const deleteParticipantToTicket = (key, email) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/jira/${key}/participant`, {
      data: { email: email },
    });
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
    toast.success('Participant Successfully Removed');
    toast.success('It may take up to 2 minutes for the changes to reflect');
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
    // toast.error(err?.response?.data?.detail);
    dispatch(getJiraTicketByKey(key));
    dispatch(getJiraProjectByKey(key));
  }
};
// Transition Status of Ticket
export const transitionTicket =
  (key, transitionID, comment, toggle, navigate, prevTicketPageRoute) => async (dispatch) => {
    try {
      dispatch(startTicketTransition());
      toast.warning('Please wait while we transition the ticket');
      toggle();
      const response = await API.put(`/jira/${key}/transition`, {
        transitionID,
        comment,
      });

      dispatch(setJiraTicketByKey(response?.data));
      toast.success('Transition Successful');
      if (transitionID == '1021' || transitionID == '1011') {
        navigate(prevTicketPageRoute);
      }
    } catch (err) {
      dispatch(stopTicketTransition());
      raiseErrorException(err, dispatch, setReducerError, 'put');
    }
  };
// Transition Status of Ticket
export const transitionTicketForCustomTable =
  (key, transitionID, label, id, dataLabel, updateCellValue, fetchData, currentPage, navigate, prevTicketPageRoute) =>
  async (dispatch) => {
    try {
      dispatch(start());
      console.log({
        key,
        transitionID,
        label,
        id,
        dataLabel,
        updateCellValue,
        fetchData,
        currentPage,
        navigate,
        prevTicketPageRoute,
      });
      toast.warning('Please wait while we transition the ticket');
      const response = await API.put(`/jira/${key}/transition`, {
        transitionID,
        // comment,
      });
      dispatch(setJiraTicketByKey(response?.data));
      toast.success('Transition Successful');
      if (transitionID == '1021' || transitionID == '1011') {
        navigate(prevTicketPageRoute);
      }
      // updateCellValue(label, id, dataLabel)
      // console.log('currentPage', currentPage)
      fetchData(currentPage);
    } catch (err) {
      console.log('Error', err);
      raiseErrorException(err, dispatch, setReducerError, 'put');
    }
  };

// Toggle create Jira Ticket Modal
export const toggleJiraTicketModal = () => async (dispatch) => {
  dispatch(setToggleModal());
};

// get assignee
export const getAssignees = (cancelTokenSource) => async (dispatch) => {
  try {
    dispatch(startAssigneesLoading());
    const response = await API.get(`/jira/fields/assignees`, {
      cancelToken: cancelTokenSource ? cancelTokenSource.token : '',
    });
    return dispatch(setAssignees(response?.data));
  } catch (err) {
    dispatch(stopAssigneesLoading());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const getSelectedCustomerAssignees = (customerID) => async (dispatch) => {
  try {
    dispatch(startAssigneesLoading());

    const response = await StnAPI.get(`/jira/fields/assignees`, {
      headers: {
        'x-customer-id': customerID,
        'x-site-id': useSiteId(),
      },
    });

    return dispatch(setSelectedCustomerAssignees(response?.data));
  } catch (err) {
    dispatch(stopAssigneesLoading());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// get Service Codes
export const getServiceCodes = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/jira/fields/servicecodes`);

    return dispatch(setServiceCodes(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// generate timecards for Quickbook (action not used)
export const generateTimeCards = () => async (dispatch) => {
  try {
    const response = await API.get('/jira/timetracking/timecard');
    return;
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Create New Jira Ticket
export const createJiraTicket =
  (fields, toggle, toggling, setToggling, token, refresh, isLoading, setIsLoading) => async (dispatch) => {
    try {
      const currentCustomerID = useCustomerId();
      const currentSiteID = useSiteId();
      dispatch(start());
      toast.info('Please Wait While We Create Your Ticket');

      const { files, ...rest } = fields;
      const response = await StnAPI.post(`/jira/`, rest, {
        headers: {
          'x-customer-id': rest?.customerID || currentCustomerID,
          'x-site-id': rest?.siteID || currentSiteID,
        },
      });

      dispatch(
        setNewTicketAndAllTickets({
          newticket: response?.data?.newTicket,
          tickets: response?.data?.allTickets?.issues,
        }),
      );

      if (files) {
        const key = response?.data?.newTicket?.key;
        if (key && response.status === 201) {
          dispatch(attachFileToJiraTicketByKey(key, files));
        }
      }
      toggle();
      toast.success('Ticket was Successfully Created');
      if (isLoading) {
        setIsLoading(!isLoading);
      }
      setToggling(!toggling);
    } catch (err) {
      if (isLoading) {
        setIsLoading(false);
      }
      if (err.response.status === 412) {
        dispatch(UpdateCredsAction(token, refresh));
      }
      raiseErrorException(err, dispatch, setReducerError, 'post');
      // toast.error(err?.response?.data?.detail);
    }
  };

export const getAllProjects = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get('/jira/projects/all?includeSubtickets=false');

    return dispatch(setAllProjects(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const bulkUpdateModalToggle = () => async (dispatch) => dispatch(setToggleBulkUpdateModal());

// get assignee ticket counts
export const getUserTicketData = (userID) => async (dispatch) => {
  try {
    dispatch(startUserTicketData());
    const response = await API.get(`/jira/assignee/${userID}/counts`);
    return dispatch(setUserTicketData(response?.data));
  } catch (err) {
    dispatch(stopUserTicketData());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
// get analyse alerts
export const getAlienVaultAnalyseAlert = (alertID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/alienvault/alert/${alertID}`);
    dispatch(setAnalyseAlertData(response?.data));
  } catch (err) {
    toast.error(err?.response?.data?.detail);
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
// get analyse alerts
export const getSentineloneAnalyseAlert = (alertID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/sentinelone/alert/log/${alertID}`);
    dispatch(setAnalyseAlertData(response?.data));
  } catch (err) {
    toast.error(err?.response?.data?.detail);
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
// post analyse alerts
export const setSentinelOneAnalyseAlert = (key, alertID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/sentinelone/alert/${alertID}/analyze`);
    dispatch(setAnalyseAlertDataWithAlertID(response?.data));
    dispatch(getSentineloneAnalyseAlert(alertID));
    toast.success('Alert Analyzed Successfully');
  } catch (err) {
    toast.error(err?.response?.data?.detail);
    raiseErrorException(err, dispatch, setReducerError, 'post');
  }
};
// alienvault post analyse alerts
export const setalienvaultAnalyseAlert = (key, alertID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/alienvault/alert/${alertID}/analyze`);
    dispatch(setAnalyseAlertDataWithAlertID(response?.data));
    dispatch(getAlienVaultAnalyseAlert(alertID));
    toast.success('Alert Analyzed Successfully');
  } catch (err) {
    // toast.error(err?.response?.data?.detail);
    raiseErrorException(err, dispatch, setReducerError, 'post');
  }
};

// Add Jira API Key
export const addJiraApiKey = (key, isEncrypted) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post('/jira/api_key', {
      key,
      isEncrypted,
    });

    dispatch(setJiraApiKey(response?.data));
    toast.success('Jira API Key Successfully Added');
  } catch (err) {
    // toast.error(err?.response?.data?.detail);
    raiseErrorException(err, dispatch, setReducerError, 'post');
  }
};

// Check Jira API Key Status
export const checkJiraApiKeyStatus = (userID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/jira/api_key/user/${userID}`);
    dispatch(setJiraApiKeyStatus(response?.data));
    return true; // Return true for successful validation
  } catch (err) {
    // Don't show error toast for 404 since it's expected when key isn't set
    if (err.response?.status !== 404) {
      toast.error(err?.response?.data?.detail);
    }
    dispatch(setJiraApiKeyStatus(null));
    return false; // Return false for failed validation
  }
};

export const updateTicketDetails = (key, data, dataFor) => async (dispatch) => {
  try {
    console.log({
      key,
      data,
      dataFor,
    });
    if (dataFor == 'priority') {
      dispatch(startPriorityFieldLoading());
    }
    if (dataFor == 'project') {
      dispatch(startProjectFieldLoading());
    }
    if (dataFor == 'description') {
      dispatch(startDescriptionFieldLoading());
    }
    if (dataFor == 'labels') {
      dispatch(startLabelsFieldLoading());
    }
    if (dataFor == 'reporter') {
      dispatch(startReporterFieldLoading());
    }
    if (dataFor == 'assignee') {
      dispatch(startAssigneeFieldLoading());
    }
    if (dataFor == 'serviceCode') {
      dispatch(startServiceCodeFieldLoading());
    }
    if (dataFor == 'team') {
      dispatch(startAssignTeamFieldLoading());
    }
    if (dataFor == 'startDate') {
      dispatch(startStartDateFieldLoading());
    }
    if (dataFor == 'duedate') {
      dispatch(startDueDateFieldLoading());
    }
    if (dataFor == 'timeEstimate') {
      dispatch(startTimeEstimateFieldLoading());
    }
    if (dataFor == 'statusSummary') {
      dispatch(startStatusSummaryFieldLoading());
    }
    if (dataFor == 'customerID') {
      dispatch(startCustomerIDFieldLoading());
    }
    if (dataFor == 'siteID') {
      dispatch(startSiteIDFieldLoading());
    }

    const response = await API.patch(`/jira/${key}?sparseFields=true`, data);

    toast.success('Ticket details updated successfully');
    return response?.data;
  } catch (err) {
    if (dataFor == 'priority') {
      dispatch(stopPriorityFieldLoading());
    }
    if (dataFor == 'project') {
      dispatch(stopProjectFieldLoading());
    }
    if (dataFor == 'description') {
      dispatch(stopDescriptionFieldLoading());
    }
    if (dataFor == 'labels') {
      dispatch(stopLabelsFieldLoading());
    }
    if (dataFor == 'reporter') {
      dispatch(stopReporterFieldLoading());
    }
    if (dataFor == 'assignee') {
      dispatch(stopAssigneeFieldLoading());
    }
    if (dataFor == 'serviceCode') {
      dispatch(stopServiceCodeFieldLoading());
    }
    if (dataFor == 'team') {
      dispatch(stopAssignTeamFieldLoading());
    }
    if (dataFor == 'startDate') {
      dispatch(stopStartDateFieldLoading());
    }
    if (dataFor == 'duedate') {
      dispatch(stopDueDateFieldLoading());
    }
    if (dataFor == 'timeEstimate') {
      dispatch(stopTimeEstimateFieldLoading());
    }
    if (dataFor == 'statusSummary') {
      dispatch(stopStatusSummaryFieldLoading());
    }
    if (dataFor == 'customerID') {
      dispatch(stopCustomerIDFieldLoading());
    }
    if (dataFor == 'siteID') {
      dispatch(stopSiteIDFieldLoading());
    }
    // toast.error(err?.response?.data?.detail || 'Failed to update ticket details');
    raiseErrorException(err, dispatch, setReducerError, 'patch');
  }
};

export const getAllJiraProjects = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get('/jira/projects/tickets?showSupport=false');
    return dispatch(setAllJiraProjects(response?.data));
  } catch (err) {
    dispatch(setAllJiraProjects([]));
    raiseErrorException(err, dispatch, setReducerError, 'patch');
  }
};

export const downloadReportTest = (route, searchquery, siteID, customerID) => async (dispatch) => {
  try {
    const downloadMessage = toast.info('Downloading Report...');
    const API_URL = siteID || customerID ? StnAPI : API;

    const response = await API_URL.get(`${route}?${searchquery}`, {
      responseType: 'blob',
      headers: {
        'x-site-id': siteID,
        'x-customer-id': customerID || getLocalStorageData('currentCustomerID'),
      },
    });
    const header = response.headers['content-disposition'];
    let filename = header.substring(header.indexOf('"') + 1, header.lastIndexOf('"'));
    if (!filename) {
      filename = decodeURI(header.substring(header.lastIndexOf("'") + 1));
    }
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);

    link.addEventListener('load', () => {
      window.URL.revokeObjectURL(url);
      link.remove();
    });

    document.body.appendChild(link);
    link.click();

    toast.update(downloadMessage, {
      render: 'Download Successful',
      type: 'success',
      isLoading: false,
      autoClose: 1000,
    });
    return response?.data;
  } catch (err) {
    const errMsg = err?.response?.data?.detail || 'Failed to download report';
    toast.error(errMsg);
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const downloadReport = (response) => async (dispatch) => {
  console.log('downloadReport called with response:', response);
  try {
    const header = response.headers['content-disposition'];
    let filename = header.substring(header.indexOf('"') + 1, header.lastIndexOf('"'));
    if (!filename) {
      filename = decodeURI(header.substring(header.lastIndexOf("'") + 1));
    }
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);

    link.addEventListener('load', () => {
      window.URL.revokeObjectURL(url);
      link.remove();
    });

    document.body.appendChild(link);
    link.click();

    toast.success('Download Successful');
    return response?.data;
  } catch (err) {
    console.log('Error downloading report:', err);
    // toast.error(err?.response?.data?.detail);
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const getJiraTicketSpecialInstructionsData = (key) => async (dispatch) => {
  try {
    dispatch(startSpecialInstructionsLoading());
    const response = await API.get(`/jira/${key}/calltree`);
    return dispatch(setSpecialInstructionsData(response?.data));
  } catch (err) {
    dispatch(stopSpecialInstructionsLoading());
    if (err?.response?.status === 400) {
      return dispatch(setSpecialInstructionsData(null));
    } else {
      toast.error(err?.response?.data?.detail || 'Failed to get special instructions data');
    }
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const getJiraTicketTeamData = () => async (dispatch) => {
  try {
    dispatch(startTeamFieldLoading());
    const response = await API.get(`/jira/teams?url=123`);
    return dispatch(setJiraTicketTeamData(response?.data));
  } catch (err) {
    dispatch(stopTeamFieldLoading());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
